import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';

import { LABEL_TYPES } from 'constants/components';
import { colors } from 'muiTheme/palette';

const labelProps = {
  [LABEL_TYPES.TEAMMATE]: {
    labelText: 'Teammate',
    textColor: 'text.primary',
    backgroundColor: colors.teammate,
    width: 120,
  },
  [LABEL_TYPES.ORG_ADMIN]: {
    labelText: 'Org Admin',
    textColor: 'text.primary',
    backgroundColor: colors.orgAdmin,
    width: 120,
  },
  [LABEL_TYPES.CULTURE_PROJECT]: {
    labelText: 'Culture Project',
    textColor: 'text.secondary',
    backgroundColor: colors.cultureColor,
    width: { xs: 156, md: 200 },
  },
  [LABEL_TYPES.FEEDBACK_FRAMEWORK]: {
    labelText: 'Feedback Framework',
    textColor: 'text.secondary',
    backgroundColor: colors.frameworkColor,
    width: 200,
  },
  [LABEL_TYPES.PUBLIC_PROJECT]: {
    labelText: 'Public Project',
    textColor: 'text.secondary',
    backgroundColor: colors.publicProject,
    width: 200,
  },
  [LABEL_TYPES.PRIVATE_PROJECT]: {
    labelText: 'Private Project',
    textColor: 'text.secondary',
    backgroundColor: colors.privateProject,
    width: 200,
  },
  [LABEL_TYPES.PUBLIC_PROJECT_SHORT]: {
    labelText: 'Public',
    textColor: 'text.secondary',
    backgroundColor: colors.publicProject,
    width: 80,
  },
  [LABEL_TYPES.PRIVATE_PROJECT_SHORT]: {
    labelText: 'Private',
    textColor: 'text.secondary',
    backgroundColor: colors.privateProject,
    width: 80,
  },
};

const styles = {
  chip: (backgroundColor, width) => ({
    paddingBlock: 1,
    cursor: 'inherit',
    backgroundColor,
    width,
    '&:hover': {
      backgroundColor,
    },
    '.MuiChip-label': {
      paddingInline: 0,
    },
  }),
};

const Label = ({ labelType }) => {
  const { labelText, textColor, backgroundColor, width } = labelProps[labelType] ?? {};

  return (
    <Chip
      label={
        <Typography variant="body2" component="span" color={textColor}>
          {labelText}
        </Typography>
      }
      sx={styles.chip(backgroundColor, width)}
    />
  );
};

Label.propTypes = {
  labelType: PropTypes.oneOf(Object.values(LABEL_TYPES)).isRequired,
};

export default Label;
